import request from '@/utils/server'
// 新增
  export function add(data) {
    return request({
      url: '/customer/add',
      
      method: 'POST',
      data: data
    })
  }
//   修改
export function edit(data) {
    return request({
      url: '/customer/edit',
      method: 'POST',
      data: data
    })
  }
//   请求列表
  export function getCustomerList(query) {
    return request({
      url: '/customer/getCustomerList',
      
      method: 'get',
      params: query
    })
  }
  // 删除
  export function delCustomer(data) {
    return request({
      url: '/customer/delCustomer',
      method: 'POST',
      data: data
    })
  }